export const THEME_LIGHT = "light" as const;
export const THEME_DARK = "dark" as const;
export const themeNames = { light: THEME_LIGHT, dark: THEME_DARK } as const;
export type ThemeName = (typeof themeNames)[keyof typeof themeNames];
